import React from 'react'
import _ from 'lodash'

import {Row, Col} from 'react-flexbox-grid'

import {NetworkService} from 'api/network'
import {Form, Input, Submit} from 'forms'

export class CreateNetwork extends React.Component {
   constructor() {
      super()

      this.state = {
         network: {}
      }

      this.handleSubmit = this.handleSubmit.bind(this)
   }

   static get propTypes() {
      return {
         routes: React.PropTypes.array.isRequired,
         router: React.PropTypes.object.isRequired
      }
   }

   handleSubmit(ev, patch) {
      const data = _.omit(patch, '$autoCreate')

      return NetworkService.create(data).then(network => {
         // redirect to network specific setup guide
         const pathname = _.map(this.props.routes, ({path}) => path)
            .concat([network.key])
            .join('/')
            .replace(/^\//, '')

         this.props.router.push({
            pathname,
            query: {autoCreate: patch.$autoCreate}
         })
      })
   }

   render() {
      return (
         <Row style={{marginTop: '3em'}}>
            <Col md={6}>
               <div className="page-header">
                  <h4>Create Network</h4>
               </div>
               <Form onSubmit={this.handleSubmit} defaultValues={{$autoCreate: true, name: ''}}>

                  <Form.Updated>Network was successfully updated</Form.Updated>
                  <Form.Error>Some error occurred during Network Creation</Form.Error>

                  <Input label="Network Name" type="text" param="name" />

                  <Input label="Create default gateway?" type="checkbox" param="$autoCreate" />

                  <div style={{clear: 'both'}} className="text-right">
                     <Submit icon="check">Create Network</Submit>
                  </div>

               </Form>
            </Col>

            <Col md={6}>
               <p style={{marginTop: '3em', marginBottom: '2rem'}}>
                  A Tinymesh Network enables one or more Tinymesh Gateways
                  to communicate over the Tinymesh Cloud API's.
               </p>

               <p>
                  After creating your Network and Gateway definition in the Cloud API
                  you can set the Network ID in the physical Gateway Devices configuration memory.
                  This allows it to connect authenticate with the the Tinymesh Cloud.
                  By default a default gateway will be created, you can choose to
                  manually create a gateway by disabling the
                  {' '}
                  <em>Create default gateway</em>
                  .
               </p>
            </Col>
         </Row>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/setup-guide/CreateNetwork.jsx